import { DROPOFF_PHASE_COLOR, PICKUP_PHASE_COLOR } from './loadPhase';

export const DropoffSiteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="16"
      r="15"
      fill={DROPOFF_PHASE_COLOR}
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M24 16L22.59 14.59L17 20.17V8H15V20.17L9.42 14.58L8 16L16 24L24 16Z"
      fill="white"
    />
  </svg>
);

export const PickupSiteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="18"
      cy="18"
      r="17"
      fill={PICKUP_PHASE_COLOR}
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M10 18L11.41 19.41L17 13.83V26H19V13.83L24.58 19.42L26 18L18 10L10 18Z"
      fill="white"
    />
  </svg>
);

export const StagingSiteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="15" fill="#0891B2" stroke="white" strokeWidth="2" />
    <path
      d="M16 8L14.59 9.41L20.17 15H8V17H20.17L14.58 22.58L16 24L24 16L16 8Z"
      fill="white"
    />
  </svg>
);

export const BothSiteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="15" fill="#1B2480" stroke="white" strokeWidth="2" />
    <path
      d="M20 21.01V14H18V21.01H15L19 25L23 21.01H20ZM13 7L9 10.99H12V18H14V10.99H17L13 7ZM20 21.01V14H18V21.01H15L19 25L23 21.01H20ZM13 7L9 10.99H12V18H14V10.99H17L13 7Z"
      fill="white"
    />
  </svg>
);
